import { render, staticRenderFns } from "./BtnQuote.vue?vue&type=template&id=270d22ec"
import script from "./BtnQuote.vue?vue&type=script&lang=js"
export * from "./BtnQuote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports